import React from "react";

export default function Button({text}){

	return(
      	<div>
                  <button>
                        {text}
                  </button>
      
      	</div>
	)

}